import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FaTimesCircle } from "react-icons/fa";
import ModalCloseIcon from "../../assets/svg/close-modal.svg";
import { ReactComponent as MinusSign } from "../../assets/svg/minus-sign.svg";
import { ReactComponent as PlusSign } from "../../assets/svg/add-circle.svg";
import Attachment from "../../assets/svg/attachment.svg";
import Upload from "../../assets/svg/gateoutupload.svg";
import Camera from "../../assets/svg/gateoutcamera.svg";
import close from "../../assets/svg/close-modal.svg";
import { Container, Row, Col } from "react-bootstrap";
import len from "../../assets/svg/lentra.svg";
import AsyncSelect from "react-select/async";
import { getEnabledFieldApi, getReasonApi } from "../visitor/visitor-api.js";

import profile from "../../assets/svg/profile.svg";
import { getTransporterListApi, getCustomerListApi, getVehicleCustomer } from "../vehicle/vehicle-api";

import production from "../../assets/svg/production.svg";
import check_failed from "../../assets/svg/druken.svg";
import temp from "../../assets/svg/temp.svg";
import add from "../../assets/svg/add.svg";
import nandhu from "../../assets/svg/nandhu.svg";
import { ReactComponent as ItemNameIcon } from "../../assets/svg/itemname.svg";
import { ReactComponent as QuantityIcon } from "../../assets/svg/Quantity.svg";
import { ReactComponent as DescriptionIcon } from "../../assets/svg/Description.svg";
import { ReactComponent as MoreIcon } from "../../assets/svg/more.svg";
import "./gate-out-modal.css";
import AddItemModal from "./add-item-modal";
import userTemp from "../../assets/png/customer-icon.png";
import { getFailedCheckList } from "../visitor/visitor-api";
import CustomerCreateModal from "./customer-create-modal.js";
import AddMaster from "../../assets/svg/add-master.svg";
import SearchWithAPI from "../common/searchbox/searchbox.js";

const GateOutModal = ({ moduleName, visitorDetails, onProceed, onCancel }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const [validations, setValidations] = useState({
    customers: "",
  });
  const [errorMessage, setErrorMessage] = useState("");
  const [error, setError] = useState("");
  const [errorGateOutAttach, setErrorGateOutAttach] = useState("");
  const [errorReasonError, setErrorreasonError] = useState("");
  const [showCapturedOutImage, setShowCapturedOutImage] = useState(false);

  const [star, setStar] = useState("");
  const [alertItemIndex, setAlertItemIndex] = useState(null);
  const [selectedCustomerLabels, setSelectedCustomerLabels] = useState([]);
  const [reasonOption, setReasonOption] = useState(null);
  const handleGateDropdownChange = (option) => {
    console.log(option);
    setReasonOption(option);


  };
  const [showCustomerCreateModal, setCustomerCreateModal] = useState(false);

  const [showAddItemModal, setAddItemModal] = useState(false);
  const [enabledFields, setEnabledFields] = useState([]);
  const [reasonLabel, setReasonLabel] = useState('');

  const [mandatoryFields, setMandatoryFields] = useState([]);

  const [itemData, setItemData] = useState(null);
  const [itemList, setItemList] = useState([]);
  const [checkList, setCheckList] = useState([]);

  //Capture PopUp
  //const [capturedImageOut, setCapturedImageOut] = useState(null);
  const [imageList, setImageList] = useState([]);
  const [isGateOutRemarksRequired, setIsGateOutRemarksRequired] = useState(false);
  const [gateOutRemarksRequired, setGateOutRemarksRequired] = useState("");
  const [remarks, setRemarks] = useState("");

  const [photoOut, setPhotoOut] = useState(false);
  const videoOutRef = useRef(null);
  const canvasOutRef = useRef(null);

  const openOutModal = () => {
    //setCapturedImageOut(null);
    setPhotoOut(true);
  };
  const closeOutModal = () => {
    stopCameraOut();
    setPhotoOut(false);
  };

  const startCameraOut = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      if (videoOutRef.current) {
        videoOutRef.current.srcObject = stream;
        videoOutRef.current.play();
      }
    } catch (err) {
      console.error("Camera access error:", err);
      alert("Please allow camera access.");
      setPhotoOut(false);
    }
  };

  const stopCameraOut = () => {
    if (videoOutRef.current && videoOutRef.current.srcObject) {
      videoOutRef.current.srcObject.getTracks().forEach((track) => track.stop());
      videoOutRef.current.srcObject = null;
    }
  };

  // const captureImageOut = () => {
  //   const video = videoOutRef.current;
  //   const canvas = canvasOutRef.current;

  //   canvas.width = 420;
  //   canvas.height = 250;

  //   const ctx = canvas.getContext("2d");
  //   const videoWidth = video.videoWidth;
  //   const videoHeight = video.videoHeight;
  //   const targetAspect = 420 / 250;
  //   const videoAspect = videoWidth / videoHeight;

  //   let sx, sy, sw, sh;

  //   if (videoAspect > targetAspect) {
  //     sh = videoHeight;
  //     sw = sh * targetAspect;
  //     sx = (videoWidth - sw) / 2;
  //     sy = 0;
  //   } else {
  //     sw = videoWidth;
  //     sh = sw / targetAspect;
  //     sx = 0;
  //     sy = (videoHeight - sh) / 2;
  //   }

  //   ctx.drawImage(video, sx, sy, sw, sh, 0, 0, 420, 250);
  //   const imageDataURL = canvas.toDataURL("image/png");
  //   stopCameraOut();
  //   setCapturedImageOut(imageDataURL);
  //   setUploadedImageOut(null);
  // };

  const captureImageOut = () => {
    const video = videoOutRef.current;
    const canvas = canvasOutRef.current;

    canvas.width = 420;
    canvas.height = 250;

    const ctx = canvas.getContext("2d");
    const videoWidth = video.videoWidth;
    const videoHeight = video.videoHeight;
    const targetAspect = 420 / 250;
    const videoAspect = videoWidth / videoHeight;

    let sx, sy, sw, sh;
    if (videoAspect > targetAspect) {
      sh = videoHeight;
      sw = sh * targetAspect;
      sx = (videoWidth - sw) / 2;
      sy = 0;
    } else {
      sw = videoWidth;
      sh = sw / targetAspect;
      sx = 0;
      sy = (videoHeight - sh) / 2;
    }

    ctx.drawImage(video, sx, sy, sw, sh, 0, 0, 420, 250);
    const imageDataURL = canvas.toDataURL("image/png");

    stopCameraOut();
    setImageList((prev) => [...prev, imageDataURL]);
    setPhotoOut(false);
  };

  useEffect(() => {
    if (photoOut) startCameraOut();
    return () => stopCameraOut();
  }, [photoOut]);

  const removeImage = (indexToRemove) => {
    setImageList((prev) => prev.filter((_, index) => index !== indexToRemove));
  };

  //Capture Over

  //Upload
  //const [uploadedImageOut, setUploadedImageOut] = useState(null);

  const handleUploadImageOut = (e) => {
    const files = Array.from(e.target.files);
    const validFiles = files.filter((file) => ["image/jpeg", "image/png", "image/jpg"].includes(file.type));

    validFiles.forEach((file) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64Data = reader.result;
        setImageList((prev) => {
          // Add only if it's not already in the list
          if (!prev.includes(base64Data)) {
            return [...prev, base64Data];
          } else {
            return prev;
          }
        });
      };
      reader.readAsDataURL(file);
    });

    e.target.value = ""; // Clear file input
  };

  const getEnabledField = async () => {
    const data = {
      type: "Vehicle",
      gate_id: visitorDetails.gate_id ?? '',
      department_id: visitorDetails.department_id ?? ''
    };
    try {
      const response = await getEnabledFieldApi(data);
      if (response.success === true) {
        setEnabledFields(response?.enabled_fields ?? {});
        setMandatoryFields(response?.mandatory_fields ?? {});
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getReason = async () => {

    try {
      const response = await getReasonApi(visitorDetails.id);
      console.log({ response })
      if (response.status === true) {
        setReasonLabel(response?.field ?? "");

      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  // useEffect(() => {
  //   if (moduleName === "Vehicle") {
  //     getEnabledField();
  //     getReason();
  //   }
  //   getCustomerDetails(visitorDetails.vehicle_number);
  // }, []);
  useEffect(() => {
    const init = async () => {
      if (moduleName === "Vehicle") {
        await getReason();          // Run first
        await getEnabledField();    // Run only after getReason completes
      }
      getCustomerDetails(visitorDetails.vehicle_number);
    };

    init();
  }, []);

  useEffect(() => {

  }, [reasonLabel]);

  //hello
  const getCustomerDetails = async (vehicleNumber) => {
    try {
      const response = await getVehicleCustomer(vehicleNumber, "Vehicle");
      if (response.success === true && response.message !== "Vehicle Number Not Available !!") {
        console.log(response);
        const customers = response.cutomers;
        console.log();

        setSelectedCustomer(customers?.map((item) => ({ value: String(item.value), label: String(item.label) })));
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getSafeValue = (value) => {
    return value === "" || value === null || value === undefined ? "-" : value;
  };
  const modalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      opacity: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },
    modal: {
      backgroundColor: "#ffffff",

      borderRadius: "16px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      width: "1000px",
      height: "500px",
      overflowY: "auto",
    },
  };

  const [loading, setLoading] = useState(false);
  const [itemName, setItemName] = useState("");
  const [quantity, setQuantity] = useState(1);
  const isFieldEnabled = (field) => {
    return enabledFields.some((item) => item === field);
  };
  const isMandatoryFields = (field) => {
    return mandatoryFields.some((item) => item === field);
  };

  const [description, setDescription] = useState("");
  useEffect(() => {
    getFailedCheck();
  }, [visitorDetails]);

  const alertRef = useRef(null);
  useEffect(() => {
    // Attach event listener to the document
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Clean up event listener on unmount
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const handleClickOutside = (event) => {
    if (alertRef.current && !alertRef.current.contains(event.target)) {
      setAlertItemIndex(null); // Close the alert
    }
  };
  const onSaveItem = (itemData) => {
    setAddItemModal(false);
    const tempItem = [...itemList];
    if (itemData.index === null) {
      tempItem.push(itemData.item);
    } else {
      tempItem[itemData.index] = itemData.item;
    }
    setItemList(tempItem);
  };
  const getFailedCheck = async () => {
    try {
      const response = await getFailedCheckList(visitorDetails.id, moduleName);
      if (response.success === true) {
        setCheckList(response.suggestionlist);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const isFieldMandatory = (field) => {
    return mandatoryFields.some((item) => item === field);
  };

  //dropdown

  const [selectedCustomer, setSelectedCustomer] = useState([]);

  const fetchCustomer = (inputValue, callback) => {
    setTimeout(async () => {
      console.log("Fetching transport options with term:", inputValue);
      const response = await getCustomerListApi(inputValue);
      if (response.status === 200) {
        if (response.data.success === true) {
          const options = response.data.suggestionlist.map((item) => ({
            value: String(item.value),
            label: String(item.label),
          }));
          callback(options);
        }
      }
    }, 1000);
  };

  const handleCustomerChange = (selectedOptions) => {
    console.log("hi", selectedOptions);
    setSelectedCustomer(selectedOptions);
  };

  const multiselectCustomStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "#ffffff",
      borderRadius: "8px",
      border: "0.7px solid #E5E5E5",
      padding: "2px",
      fontWeight: "500",
      fontSize: "13px",
      color: "#212129",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#007bff" : state.isFocused ? "#e0e0e0" : "#ffffff",
      color: state.isSelected ? "#ffffff" : "#333",
      padding: 10,
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#F6F7F8",
      color: "#212129",
      borderRadius: "5px",
      padding: "2px 5px",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: "#212129",
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: "#212129",
      cursor: "pointer",
      ":hover": {
        backgroundColor: "f8f9fb",
        color: "#212129",
      },
    }),
  };
  const onSuccessCustomerCreate = async (response) => {
    setCustomerCreateModal(false);
    if (response.success === true) {
      const tempCus = [...selectedCustomer];
      tempCus.push({ value: String(response.customer_id ?? ''), label: String(response.customer_name ?? '') })
      setSelectedCustomer(tempCus)
    }
    // setSnackbarMessage(response.message);
    // setSnackbarStatus(response.success);
    // handleSnackbarShow();
  };

  return (
    <div style={modalStyle.overlay}>
      {showAddItemModal && (
        <AddItemModal
          moduleName={moduleName}
          itemData={itemData}
          onSave={onSaveItem}
          onCancel={() => {
            setAddItemModal(false);
            setItemData(null);
          }}
        />
      )}
      {showCustomerCreateModal && <CustomerCreateModal povId={null} onSuccess={onSuccessCustomerCreate} onCancel={() => setCustomerCreateModal(false)} />}
      <div style={modalStyle.modal}>
        <div>
          <div className="modal-header style-justify-between">
            <div className="modal-title">Gate out</div>
            <img src={ModalCloseIcon} alt="Close" onClick={onCancel} style={{ cursor: "pointer", width: "30px", height: "30px", borderRadius: "50%" }} />
          </div>

          <div style={{ display: "flex", gap: "8px" }}>

            <div
              style={{
                width: "40%",
                background: "#fff",
                borderRadius: "12px",
                boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "15px",
              }}>

              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <img src={visitorDetails.profilephoto !== "" && visitorDetails.profilephoto ? visitorDetails.profilephoto : userTemp} alt="Profile" style={{ width: "40px", height: "40px", borderRadius: "50%" }} />
                <div>
                  <div className="visitor-name">
                    {getSafeValue(visitorDetails.visitor_name)} {visitorDetails.driver_name ?? ""}
                  </div>
                  {moduleName === "Visitor" && (
                    <div>
                      <img src={len} alt="" /> <span className="org-title">{getSafeValue(visitorDetails.organization)}</span>
                    </div>
                  )}
                  {moduleName === "Vehicle" && (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div className="field-title pt-1">{getSafeValue(visitorDetails.vehicle_number)}</div> <span className="dot-span mx-2"></span> <div className="vehicle-type-card px-2 pt-1">{visitorDetails.vehicle_type}</div>
                    </div>
                  )}
                </div>
              </div>

              {/* Info Badges */}
              <div style={{ display: "flex", gap: "10px", marginTop: "12px" }}>
                <div className="in-time-card px-2 py-1">
                  <span className="in-time-title">In time</span>
                  <div className="font-13-600">{getSafeValue(visitorDetails.in_time)}</div>
                </div>
                <div className="in-time-card  px-2 py-1">
                  <span className="in-time-title">Purpose of visit</span>
                  <div className="font-13-600">{getSafeValue(visitorDetails.visit_purpose)}</div>
                </div>
              </div>

              {/* Details */}
              <div className="detail-card mt-2">
                <div className="details font-15-700">Details</div>
                <div className="px-2 pt-2">
                  <div className="style-justify-start" style={{ flex: 10 }}>
                    <div style={{ flex: 3 }} className="font-13-400-626F86">
                      Meeting type
                    </div>
                    <div style={{ flex: 7 }} className="font-13-500-172B4D">
                      {getSafeValue(visitorDetails.meeting_type)}
                    </div>
                  </div>
                  <div className="style-justify-start mt-1" style={{ flex: 10 }}>
                    <div style={{ flex: 3 }} className="font-13-400-626F86">
                      Email
                    </div>
                    <div style={{ flex: 7 }} className="font-13-500-172B4D">
                      {getSafeValue(visitorDetails.email)}
                    </div>
                  </div>
                  <div className="style-justify-start mt-1" style={{ flex: 10 }}>
                    <div style={{ flex: 3 }} className="font-13-400-626F86">
                      Mobile number
                    </div>
                    <div style={{ flex: 7 }} className="font-13-500-172B4D">
                      {getSafeValue(visitorDetails.mobile_number)}
                    </div>
                  </div>
                  <div className="style-justify-start mt-1" style={{ flex: 10 }}>
                    <div style={{ flex: 3 }} className="font-13-400-626F86">
                      Location
                    </div>
                    <div style={{ flex: 7 }} className="font-13-500-172B4D">
                      {getSafeValue(visitorDetails.location)}
                    </div>
                  </div>
                  <div className="style-justify-start mt-1" style={{ flex: 10 }}>
                    <div style={{ flex: 3 }} className="font-13-400-626F86">
                      Entry Gate
                    </div>
                    <div style={{ flex: 7 }} className="font-13-500-172B4D">
                      {getSafeValue(visitorDetails.gate)}
                    </div>
                  </div>

                  {moduleName === "Visitor" && (
                    <div className="mt-3 mb-2" style={{ backgroundColor: "#F9F9F9", padding: "20px", borderRadius: "12px", boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)", fontFamily: "Arial, sans-serif", border: "1px solid #e0e0e0" }}>
                      <div style={{ position: "relative" }}>
                        <div className="w-100 meeting-person-dotted"></div>
                        <span style={{ position: "absolute", top: "-12px", left: "50%", transform: "translateX(-50%)", backgroundColor: "#ffffff", padding: "4px 12px", borderRadius: "12px", fontSize: "12px", color: "#5f6368", fontWeight: "500" }}>Meeting person</span>
                      </div>
                      <div className="style-justify-start mt-3">
                        <img style={{ width: "50px", height: "50px", borderRadius: "50%", objectFit: "cover", marginRight: "12px", border: "1px solid #e0e0e0" }} src={visitorDetails.meeting_person_profile ?? userTemp} alt="Profile" />
                        <div style={{ display: "flex", flexDirection: "column" }}>
                          <span style={{ fontSize: "16px", fontWeight: "bold", color: "#202124", marginBottom: "2px" }}>
                            {getSafeValue(visitorDetails.meeting_person) ?? ""} {visitorDetails.meeting_person_name ?? ""}
                          </span>
                          <div style={{ display: "flex", alignItems: "center", fontSize: "14px", color: "#137333", fontWeight: "500" }}>
                            <img style={{ width: "16px", height: "16px", marginRight: "6px" }} src={production} alt="Briefcase Icon" />
                            {getSafeValue(visitorDetails.department)}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Right Section */}
            <div style={{ width: "60%", background: "#fff", padding: "12px", boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)" }}>
              {moduleName === "Vehicle" && isFieldEnabled("Customer") && (
                <div >
                  <div className="field-title">
                    Customer <span style={{ color: "#ff4444", fontSize: "14px", fontWeight: "400" }}>{isFieldMandatory("Customer") ? "*" : ""}</span>
                  </div>
                  <div className="mt-1">
                    <div className="style-justify-start">
                      <div style={{ flex: 1 }}>
                        <AsyncSelect isMulti cacheOptions value={selectedCustomer} loadOptions={fetchCustomer} onChange={handleCustomerChange} defaultOptions placeholder="Search customers..." styles={multiselectCustomStyles} isClearable={false} />
                      </div>
                      <div className="ps-1" onClick={() => { setCustomerCreateModal(true) }}>
                        <img src={AddMaster} alt="scan" srcSet="" />
                      </div>
                    </div>
                    <span style={{ display: "flex", alignItems: "center", justifyContent: "start", fontSize: "12px", fontWeight: 400, color: "#FF4444" }}>{error}</span>
                  </div>
                </div>
              )}
              {moduleName === "Vehicle" && isFieldEnabled(reasonLabel) && (
                <div >
                  <div className="field-title mt-2">
                    {reasonLabel} <span style={{ color: "#ff4444", fontSize: "14px", fontWeight: "400" }}>{isFieldMandatory(reasonLabel) ? "*" : ""}</span>
                  </div>
                  <div className="mt-1">
                    <div className="style-justify-start">
                      <div style={{ flex: 1 }}>
                        <SearchWithAPI onDropdownChange={handleGateDropdownChange}
                          apiUrl={apiUrl + "get_reasons"}
                          params={{
                            type: `${reasonLabel === 'Reason for No Dock Handling' ? 'without_dock_handling' : 'do_go_delay'}`
                          }}
                          placeholder={"Select"} selectedOption={reasonOption} />
                      </div>

                    </div>
                    <span style={{ display: "flex", alignItems: "center", justifyContent: "start", fontSize: "12px", fontWeight: 400, color: "#FF4444" }}>{errorReasonError}</span>
                  </div>
                </div>
              )}

              {/* Checklist */}
              <div style={{ background: "#F6F7F8", borderRadius: "24px", padding: "12px", marginTop: "16px", marginBottom: "16px" }}>
                <h4 style={{ fontSize: "14px", fontWeight: "bold" }}>Check list</h4>
                <div style={{ display: "flex", gap: "10px" }}>
                  {checkList?.map((check, index) => (
                    <span className="font-13-500-172B4D" style={{ backgroundColor: "#ffffff", padding: "4px 12px", borderRadius: "12px" }}>
                      <FaTimesCircle style={{ color: check.status === "false" ? "red" : "green" }} /> {check.checkname ?? ""} {check.creteria === "Range" ? check.value : ""}
                    </span>
                  ))}
                </div>
              </div>

              {/* Attachment*/}
              {isFieldEnabled("Gate-out attachment") && (<>
                <div style={{ fontSize: "14px", fontWeight: "bold", marginBottom: "16px" }}>Attachment{isMandatoryFields("Gate-out attachment") && <span style={{ color: "#FF4444" }}>*</span>}</div>
                <div style={{ background: "#F6F7F8", borderRadius: "24px", padding: "12px", marginBottom: "16px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                    <div>
                      <img src={Attachment} style={{ width: "35px" }} />
                    </div>

                    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                      <div style={{ fontWeight: "700", fontSize: "14px", color: "#172b4d" }}>Choose image or capture image</div>
                      <div style={{ fontWeight: "400", fontSize: "12px", color: "#8790A1" }}>JPG, PNG formats only</div>
                    </div>
                  </div>

                  <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    <label style={{ display: "flex", alignItems: "center", gap: "8px", backgroundColor: "#ffffff", border: "1px solid #d4dde7", height: "36px", lineHeight: "100%", borderRadius: "37px", padding: "10px 16px", cursor: "pointer" }}>
                      <img src={Upload} style={{ width: "16px" }} />
                      <span style={{ fontWeight: "700", fontSize: "13px", color: "#2C8C53" }}>Upload</span>
                      <input type="file" accept=".jpg,.jpeg,.png" style={{ display: "none" }} multiple onChange={handleUploadImageOut} />
                    </label>

                    <div onClick={openOutModal} style={{ display: "flex", alignItems: "center", gap: "8px", backgroundColor: "#2C8C53", height: "36px", lineHeight: "100%", borderRadius: "37px", padding: "10px 16px" }}>
                      <div>
                        <img src={Camera} style={{ width: "16px" }} />
                      </div>
                      <div style={{ fontWeight: "700", fontSize: "13px", color: "#ffffff" }}>Capture</div>
                    </div>

                    {photoOut && (
                      <div style={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", backgroundColor: "rgba(0, 0, 0, 0.4)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000 }}>
                        <div style={{ width: "450px", backgroundColor: "#ffffff", borderRadius: "16px", padding: "24px", boxShadow: "0 4px 8px rgba(0,0,0,0.2)", position: "relative", height: "fit-content" }}>
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "24px" }}>
                            <div style={{ fontWeight: "600", fontSize: "18px", color: "#2f3941" }}>Take a photo to confirm Gate Out</div>
                            <div>
                              <img src={close} onClick={closeOutModal} style={{ cursor: "pointer" }} />
                            </div>
                          </div>

                          <video ref={videoOutRef} style={{ borderRadius: "8px", width: "420px", height: "250px", marginBottom: "24px", backgroundColor: "#000", objectFit: "cover" }} />

                          <canvas ref={canvasOutRef} width={420} height={250} style={{ display: "none" }}></canvas>
                          <button onClick={captureImageOut} style={{ width: "100%", border: "none", borderRadius: "100px", padding: "12px 48px", backgroundColor: "#2c8c53", color: "#ffffff", fontWeight: "700", fontSize: "16px", marginBottom: "12px" }}>
                            Capture
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <span style={{ display: "flex", alignItems: "center", justifyContent: "start", fontSize: "12px", fontWeight: 400, color: "#FF4444" }}>{errorGateOutAttach}</span>
                {imageList.length > 0 && (
                  <div style={{ marginTop: "12px", marginBottom: "16px", display: "flex", flexWrap: "wrap", gap: "8px" }}>
                    {imageList.map((img, index) => (
                      <div key={index} style={{ position: "relative" }}>
                        <img src={img} alt={`Preview-${index}`} style={{ width: "100px", height: "100px", borderRadius: "6px", objectFit: "cover" }} />
                        <div onClick={() => removeImage(index)} style={{ position: "absolute", top: "-6px", right: "-6px", cursor: "pointer", fontWeight: "bold", fontSize: "14px", color: "#172b4d", padding: "2px", borderRadius: "1000px", backgroundColor: "#ebebeb" }}>
                          X
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </>)}
              {/* Carrying Items */}
              <div className="font-15-700 mt-1 mb-1">Carrying Items</div>
              <div className="item-list-header" style={{ flex: "12", marginRight: "16px" }}>
                <span className="item-list-header-txt style-justify-start" style={{ flex: "4" }}>
                  <ItemNameIcon style={{ marginRight: "8px" }} /> Item Name
                </span>
                <span className="item-list-header-txt style-justify-start" style={{ flex: "3" }}>
                  <QuantityIcon style={{ marginRight: "8px" }} /> Quantity
                </span>
                <span className="item-list-header-txt style-justify-start" style={{ flex: "5" }}>
                  <DescriptionIcon style={{ marginRight: "8px" }} /> Description
                </span>
              </div>
              <div style={{ maxHeight: "180px", overflowY: "scroll" }}>
                {visitorDetails?.itemList?.map((item, index) => (
                  <div key={"item-list" + index}>
                    <div className="item-list-row" style={{ flex: "12" }}>
                      <span className="item-list-row-txt" style={{ flex: "4" }}>
                        {item.item_name}
                      </span>
                      <span className="item-list-row-txt" style={{ flex: "3" }}>
                        {item.quantity}
                      </span>
                      <div className="item-list-row-txt" style={{ flex: "5", position: "relative" }}>
                        <span>{item.description}</span>
                      </div>
                    </div>
                  </div>
                ))}
                {itemList?.map((item, index) => (
                  <div key={"item-list" + index}>
                    <div className="item-list-row" style={{ flex: "12" }}>
                      <span className="item-list-row-txt" style={{ flex: "4" }}>
                        {item.item_name}
                      </span>
                      <span className="item-list-row-txt" style={{ flex: "3" }}>
                        {item.quantity}
                      </span>
                      <div className="item-list-row-txt" style={{ flex: "5", position: "relative" }}>
                        <span>{item.description}</span>
                        <div style={{ position: "absolute", top: "5px", right: "5px" }}>
                          <div style={{ position: "relative" }}>
                            <MoreIcon
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                setAlertItemIndex(index === alertItemIndex ? null : index);
                              }}
                            />
                            {alertItemIndex === index && (
                              <div ref={alertRef} style={{ position: "absolute", top: "40px", left: "50%", transform: "translateX(-50%)", backgroundColor: "#ffffff", color: "#1E1E1E", padding: "16px", borderRadius: "16px", boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", zIndex: 1, alignItems: "end" }}>
                                <div
                                  onClick={() => {
                                    setItemData({ item: item, index: index });
                                    setAddItemModal(true);
                                    setAlertItemIndex(null);
                                  }}
                                  style={{ cursor: "pointer", width: "150px", height: "36px", fontSize: "14px", fontWeight: "500", color: "#1E1E1E", display: "flex", alignItems: "center", justifyContent: "start" }}>
                                  Edit
                                </div>
                                <div
                                  onClick={() => {
                                    const tempItems = [...itemList];
                                    tempItems.splice(index, 1);
                                    setItemList(tempItems);
                                    setAlertItemIndex(null);
                                  }}
                                  style={{ cursor: "pointer", width: "150px", height: "36px", fontSize: "14px", fontWeight: "500", color: "#1E1E1E", display: "flex", alignItems: "center", justifyContent: "start" }}>
                                  Delete
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Buttons */}
              <button
                className="mt-2"
                style={{ background: "none", color: "#166534", border: "1px solid #E5E5E5", padding: "6px 12px", borderRadius: "5px", cursor: "pointer", marginRight: "10px" }}
                onClick={() => {
                  setAlertItemIndex(null);
                  setAddItemModal(true);
                }}>
                <img src={add} alt="" /> <span className="font-13-700-2C8C53">Add item</span>
              </button>
              {enabledFields.some((item) => (item === "Gate-out remarks")) && (<div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                <div style={{ fontWeight: "500", fontSize: "13px", color: "#172b4d" }}>Remarks</div>
                <div>
                  <textarea value={remarks} onChange={(event) => {
                    setRemarks(event.target.value);
                  }} placeholder="Enter Remarks" style={{ width: "100%", borderRadius: "8px", border: "1px solid #d4dde7", padding: "8px 16px", height: "80px", resize: "none", fontWeight: '300', fontSize: '13px', color: '#172b4d' }} />
                </div>
                <span style={{ display: "flex", alignItems: "center", justifyContent: "start", fontSize: "12px", fontWeight: 400, color: "#FF4444" }}>{gateOutRemarksRequired}</span>
              </div>)}
              <button
                style={{ width: "100%", marginTop: "10px", padding: "8px", background: "#2C8C53", color: "white", fontWeight: "bold", borderRadius: "30px", border: "none", cursor: "pointer" }}
                className="font-14-700-FFFFFF"
                onClick={() => {
                  if ((moduleName === "Vehicle" && isFieldMandatory("Customer") && selectedCustomer.length <= 0) ||
                    (isMandatoryFields("Gate-out attachment") && imageList.length === 0) ||
                    (moduleName === "Vehicle" && isFieldMandatory("Gate-out remarks") && remarks === "") || (moduleName === "Vehicle" && isFieldMandatory(reasonLabel) && reasonOption === null)) {
                    if (moduleName === "Vehicle" && isFieldMandatory("Customer") && selectedCustomer.length <= 0) {
                      setError("The customer field is required");
                    }
                    if (isMandatoryFields("Gate-out attachment") && imageList.length === 0) {
                      setErrorGateOutAttach("Attachment required!");
                    }
                    if (moduleName === "Vehicle" && isFieldMandatory("Gate-out remarks") && remarks === "") {
                      setErrorGateOutAttach("Remarks required!");
                    }
                    if (moduleName === "Vehicle" && isFieldMandatory(reasonLabel) && reasonOption === null) {
                      setErrorreasonError("The reason field is required.");
                    }
                  } else {
                    onProceed(itemList, selectedCustomer, reasonLabel, reasonOption, imageList ?? [], remarks);
                  }

                }}>
                Proceed to gate out
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GateOutModal;
